import { Timeline } from "antd";
import PositionItem from "@components/PositionItem/PositionItem";

const CollapseContent: React.FC<any> = ({
  index,
  formExpUpdate,
  setFormExpUpdate,
}) => {
  const position: any[] = [];
  formExpUpdate[index].position.forEach((ite: any, idx: number) => {
    const positionItem = {
      children: (
        <PositionItem
          experienceIndex={index}
          positionIndex={idx}
          formExpUpdate={formExpUpdate}
          setFormExpUpdate={setFormExpUpdate}
        />
      ),
      color: "#52b4b4",
    };
    position.push(positionItem);
  });
  return (
    <div className="collapse-content">
      <Timeline items={position} />
    </div>
  );
};

export default CollapseContent;